import { Play, Youtube } from "lucide-react";
import { Reveal } from "@/components/site/Motion";
import { Label, H2, Paras, CtaButton } from "@/components/site/Blocks";
import { PODCAST_URL } from "@/data/nav";

const EPISODES = [
  ["p3", "Episode 05 — How to Expand Your Business Internationally"],
  ["p2", "Episode 04 — AI. Scale. Exit. How to Scale Smart"],
  ["p5", "Episode 03 — Winning Go-to-Market in Tech: AI-Powered Storytelling That Converts"],
  ["p4", "Episode 02 — AI vs Humans: Embracing Technology Safely"],
  ["p1", "Episode 01 — Think Like This, and Sell Better"],
];

const Tile = ({ f, alt, i }) => {
  const big = i === 0;
  return (
    <Reveal delay={i * 0.06} className={big ? "sm:col-span-2 lg:row-span-2" : ""}>
      <a href={PODCAST_URL} target="_blank" rel="noopener noreferrer" data-testid={`podcast-tile-${i}`}
        className="group relative block aspect-video w-full overflow-hidden rounded-3xl bg-[#140d26] lg:h-full">
        <img src={`/podcast/${f}.webp`} alt={alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0716]/70 via-transparent to-transparent opacity-70 transition-opacity duration-500 group-hover:opacity-100" />
        <span className={`absolute bottom-4 right-4 flex items-center justify-center rounded-full bg-white/15 text-white backdrop-blur-md transition-[background-color,transform] duration-500 group-hover:scale-110 group-hover:bg-red-600 ${big ? "h-16 w-16" : "h-12 w-12"}`}>
          <Play className={big ? "h-6 w-6" : "h-4 w-4"} fill="currentColor" />
        </span>
      </a>
    </Reveal>
  );
};

export const Podcast = () => (
  <section data-testid="podcast-section" className="grain relative overflow-hidden bg-ink py-24 text-white sm:py-32">
    <div aria-hidden="true" className="absolute -left-40 top-1/3 h-[480px] w-[480px] rounded-full bg-violet-700/25 blur-[140px]" />
    <div className="relative mx-auto max-w-[1600px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-6">
          <Reveal><Label dark>Podcast</Label></Reveal>
          <Reveal delay={0.05}><H2 dark className="mt-6">The Perfect Digitals <span className="font-serif-i text-gradient">Podcast</span></H2></Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8">
          <Paras dark items={["Conversations about search, AI and digital growth. Watch the latest episodes on our YouTube channel."]} />
          <div className="mt-8"><CtaButton label="Watch on YouTube" href={PODCAST_URL} testid="podcast-youtube-cta" /></div>
        </Reveal>
      </div>
      <div data-testid="podcast-grid" className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:grid-rows-2">
        {EPISODES.map(([f, alt], i) => <Tile key={f} f={f} alt={alt} i={i} />)}
      </div>
      <a href={PODCAST_URL} target="_blank" rel="noopener noreferrer" data-testid="podcast-channel-link" className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-300 hover:text-white">
        <Youtube className="h-4 w-4 text-red-500" /> youtube.com/@PerfectDigitals
      </a>
    </div>
  </section>
);
